import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { isNil } from 'lodash';
import { VisualizationPanel } from 'survey-analytics';

import { StylesService } from '../../../../ui/styles/styles.service';
import { createSurveyModel } from '../../../form/utils/create-survey-model/create-survey-model';

import { VISUALIZATION_PANEL_OPTIONS } from './constants/visualization-panel-options';

@Component({
  selector: 'app-form-submission-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-submission-chart.component.html',
  styleUrls: ['./form-submission-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSubmissionChartComponent implements AfterViewInit, OnDestroy {
  ///////////////////////////////////////////////////////////////////////
  // Variables
  ///////////////////////////////////////////////////////////////////////

  private readonly stylesService = inject(StylesService);

  private visualizationPanel?: VisualizationPanel;

  @ViewChild('container', { static: true })
  private readonly container!: ElementRef<HTMLDivElement>;

  @Input()
  public formSchema!: string;

  @Input()
  public submissionData!: Record<string, unknown>[];

  ///////////////////////////////////////////////////////////////////////
  // Lifecycle
  ///////////////////////////////////////////////////////////////////////

  public async ngAfterViewInit(): Promise<void> {
    await this.stylesService.lazyLoadGlobalStyle('survey-analytics');
    this.renderVisualizationPanel();
  }

  public ngOnDestroy(): void {
    this.visualizationPanel?.destroy();
  }

  ///////////////////////////////////////////////////////////////////////
  // Private methods
  ///////////////////////////////////////////////////////////////////////

  private renderVisualizationPanel(): void {
    if (isNil(this.container)) {
      return;
    }

    const survey = createSurveyModel(this.formSchema);
    this.visualizationPanel = new VisualizationPanel(
      survey.getAllQuestions(),
      this.submissionData,
      VISUALIZATION_PANEL_OPTIONS,
    );
    this.visualizationPanel.render(this.container.nativeElement);
  }
}
